const selections = {
  data: () => ({
    farmTypes: [
      {
        value: 'plain',
        label: '平原'
      },
      {
        value: 'mountain',
        label: '山区'
      },
      {
        value: 'ocean',
        label: '海上'
      }
    ],
    turbineTypes: [
      {
        value: 'directdrive',
        label: '直驱'
      },
      {
        value: 'doublefeed',
        label: '双馈'
      }
    ],
    bindingAccesses: [
      {
        value: '1',
        label: '只读'
      },
      {
        value: '3',
        label: '读写'
      }
    ],
    userRoles: [
      {
        value: 'admin',
        label: '超级管理员'
      },
      {
        value: 'manager',
        label: '管理员'
      },
      {
        value: 'monitor',
        label: '平台监控'
      },
      {
        value: 'owner1',
        label: '一级风场主'
      },
      {
        value: 'owner2',
        label: '二级风场主'
      },
      {
        value: 'owner3',
        label: '三级风场主'
      },
      {
        value: 'owner4',
        label: '四级风场主'
      },
      {
        value: 'user1',
        label: '一级普通用户'
      },
      {
        value: 'user2',
        label: '二级普通用户'
      },
      {
        value: 'user3',
        label: '三级普通用户'
      },
      {
        value: 'user4',
        label: '四级普通用户'
      }
    ],
    userRolesColors: [
      {
        value: 'admin',
        label: 'purple'
      },
      {
        value: 'manager',
        label: 'magenta'
      },
      {
        value: 'monitor',
        label: 'teal'
      },
      {
        value: 'owner1',
        label: 'cyan'
      },
      {
        value: 'owner2',
        label: 'cyan'
      },
      {
        value: 'owner3',
        label: 'cyan'
      },
      {
        value: 'owner4',
        label: 'cyan'
      },
      {
        value: 'user1',
        label: 'gray'
      },
      {
        value: 'user2',
        label: 'gray'
      },
      {
        value: 'user3',
        label: 'gray'
      },
      {
        value: 'user4',
        label: 'gray'
      },
    ],
    userStatus: [
      {
        value: 'admitted',
        label: '通过'
      },
      {
        value: 'waitlisted',
        label: '未通过'
      }
    ]
  }),
  methods: {
    selectionsValueToLabel (value, selections){
      let selection = selections.find( (s) => {
        return s.value === value
      } )

      return selection.label
    }
  }
}

export default selections